import useTranslation from 'hooks/useTranslation'
import Submit from 'components/inputs/Submit'
import phone from '../NewWarehouse/phone.png'
import Warehouse from 'components/Warehouse'

const type = process.env.REACT_APP_TYPE

const End = ({ next }) => {
  const { t } = useTranslation('slides')
  const desc = t('manageMagDescArray')

  return (
    <>
      <i className='icon icon--logo s24' />
      <div className='slide__title center'>
        <div className='--secFont'>{t('ready')}</div>
        <div>{t(`manageMagInApp.${type}`)}</div>
      </div>

      <div className='slide__warehouses'>
        <div className='warehouse --left'>
          <Warehouse />
        </div>
        <div className='warehouse --right'>
          <Warehouse />
        </div>
        <img className='img--phone' alt='phones' src={phone} />
      </div>

      <div className='slide__desc'>
        {Array.isArray(desc)
          ? desc.map((d, i) => <div key={i}>{d}</div>)
          : desc}
      </div>

      <Submit text={t('goToPanel')} action={next} />
    </>
  )
}

export default End